import { render, staticRenderFns } from "./BoardDetailNoticeLayout.vue?vue&type=template&id=793e7b22&scoped=true&"
import script from "./BoardDetailNoticeLayout.vue?vue&type=script&lang=js&"
export * from "./BoardDetailNoticeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793e7b22",
  null
  
)

export default component.exports